/* np-spec-sheet.js — C428 (Justin 2026-09-28, "edit size feature in cart ... it needs to update all line item properties and
   perks sheet"). The build sheet ("_AI Proof" = AI render + stats, "_Upload" = digital preview + stats) used to be composed
   only inside np-emb2.js, so nothing outside the product page could rebuild it. The composer, its row builder and its
   uploader now live here, moved verbatim; np-emb2.js delegates to window.npSpecSheet and the cart's size editor
   (np-cart-size.js) uses the same code, so a sheet made in the cart is drawn exactly like one made on the product page.
   The builder's state comes in as arguments: the patch-type name, the image-host normaliser, the PUT helper. */
(function () {
  'use strict';
  if (window.npSpecSheet) return;
  var SPEC_EXCLUDE = { '_Upload': 1, 'upload': 1, '_upload': 1, '_Original Image': 1, '_cartImg': 1,
    '_AI Proof': 1, '_Preview Image': 1, '_Order Mode': 1, '_Proof Approval': 1, '_AI Proof Status': 1,
    '_AI Proof Revisions': 1, '_Revision Notes': 1, '_Remove Background': 1, '_Crop & Trim': 1, '_Proof Version': 1, /* C145: line-only */
    '_Preview Flag': 1, /* C535c: order-line only — the sheet (and its dk) never carry it */
    '_discount_input': 1, '_discount_name': 1, '_upsell': 1, 'Design Notes': 1, '_Design Notes': 1,
    'reorder': 1, 'design re-used': 1, 'AI Edit': 1,
    /* C05 (2026-08-25, Justin): keep _AI Model OFF the printed sheet. It stays
       on the ORDER for the A/B engine attribution — this only stops it being
       drawn in the spec panel, which is customer/production facing. */
    '_AI Model': 1, 'AI Model': 1,
    /* C460 (Justin 2026-09-30, "we do not need to put art fill or Proof preference on here"): both stay on the ORDER line,
       they are just never drawn on the sheet */
    '_Art Fill': 1, 'Art Fill': 1, '_Proof Preference': 1, 'Proof Preference': 1,
    /* C468: the VISIBLE twins of two pipeline flags already excluded above. The legacy uploader leaves them on the form and
       Add to Cart prunes them, so a sheet built before the click hashed two extra rows and was judged stale AT the click */
    'Crop & Trim': 1, 'Remove Background': 1,
    /* C519: the recommendation a "Keep as <type>" turned down rides the ORDER line only — never the sheet (and never its dk) */
    '_Patch Rec': 1 };
  function specLines(props, ptN) {
    var lines = [];
    /* the sheet leads with WHAT the patch is — the patch type from the
       product itself (Embroidered, Printed, Leather, ...); the caller names it */
    if (ptN) lines.push(['Patch Type', ptN]);
    var wV = props['_Width (in)'] || props['Width (in)'] || '';
    var hV = props['_Height (in)'] || props['Height (in)'] || '';
    /* C468: one format for the size rows — a typed "3" became "3.00" at Add to Cart and re-tokened every ready sheet */
    var inch = function (v) { var n = parseFloat(v); return (isFinite(n) && /^\s*[\d.]+\s*$/.test(String(v))) ? n.toFixed(2) : String(v); };
    if (wV) lines.push(['Width (in)', inch(wV)]);
    if (hV) lines.push(['Height (in)', inch(hV)]);
    Object.keys(props).forEach(function (k) {
      if (SPEC_EXCLUDE[k]) return;
      if (/width \(in\)|height \(in\)/i.test(k)) return;
      var v = String(props[k]);
      if (!v || v.indexOf('://') > -1 || v.length > 48) return;
      lines.push([k.replace(/^_+/, '').replace(/\s+$/, ''), v]);
    });
    return lines;
  }
  function specNotes(props) {
    /* revision notes ride onto the sheet as their own wrapped block */
    return String(props['_AI Proof Revisions'] || props['_Revision Notes'] || '').trim();
  }
  /* C37 (2026-08-31, Justin: "if art is white like this it does not show on the
     proof / can we do the same thing we did for AI where we put them on a grey
     background?"). Same defect C30/C31 fixed on the builder stages, one surface
     later: the SPEC SHEET is white, so white artwork on transparency renders as
     a blank panel. Order PATCH-2108594 shipped exactly that — measured at the
     60px sample the probe uses, 100% of its opaque pixels are near-white.
     Gated on ALPHA as well as tone, exactly like .is-alpha.is-lightart on the
     stages: an opaque sensei render already carries its own #f2f2f2 backdrop
     and must stay on white, or it gains a grey frame for no reason. */
  function npBitmapTone(img) {
    try {
      var W = 60, H = Math.max(1, Math.round(img.naturalHeight * (W / img.naturalWidth)));
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
      var d = x.getImageData(0, 0, W, H).data, clear = 0, opq = 0, lite = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 13) { clear++; continue; }
        opq++;
        if ((0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) > 225) lite++;
      }
      return { alpha: clear > (W * H) * 0.02, light: opq > 0 && (lite / opq) > 0.35 };
    } catch (eT) { return { alpha: false, light: false }; } /* tainted: stay on white */
  }
  function composeSpec(imgUrl, lines, notes, cb, opts) {
    if (typeof notes === 'function') { opts = cb; cb = notes; notes = ''; }
    var toImgixHost = (opts && opts.host) || function (u) { return u || ''; };
    notes = String(notes || '').trim();
    /* vector uploads (PDF/AI/EPS) can't load into an <img> — rasterize
       through imgix for the SHEET ONLY; the order keeps the true file
       (PATCH-2106506: a PDF upload shipped with no build sheet) */
    if (/\.(pdf|ai|eps)$/i.test(String(imgUrl || '').split('?')[0])) {
      var vU = toImgixHost(imgUrl);
      imgUrl = vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png&w=1200';
    }
    /* the sheet draws the patch at <=720px — decoding the FULL multi-MB
       render just to downscale it blocked the main thread for seconds
       (B40). imgix serves a 1440px rendition instead. */
    /* C468: a raw S3 base (the Mockup Lab's transparent copy, a My Proofs reorder, a hand-off's proof) cannot be read into the
       canvas — the bucket sends no CORS headers, the image errors and the sheet silently never exists. imgix fronts the same
       object WITH CORS. */
    if (/amazonaws\.com/i.test(String(imgUrl || ''))) imgUrl = toImgixHost(imgUrl);
    if (/imgix/.test(String(imgUrl)) && !/[?&]w=/.test(String(imgUrl))) {
      imgUrl += (String(imgUrl).indexOf('?') > -1 ? '&' : '?') + 'w=1440';
    }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var LH = 92, W = 1640;
        /* pre-wrap the notes so the canvas is tall enough for them */
        var probeN = document.createElement('canvas').getContext('2d');
        probeN.font = '400 34px -apple-system, "Segoe UI", sans-serif';
        var noteW = W - 870 - 40, noteLines = [];
        if (notes) {
          notes.split(/\n+/).forEach(function (para) {
            var words = para.split(/\s+/), cur = '';
            words.forEach(function (wd) {
              var t2 = cur ? cur + ' ' + wd : wd;
              if (probeN.measureText(t2).width > noteW && cur) { noteLines.push(cur); cur = wd; }
              else cur = t2;
            });
            if (cur) noteLines.push(cur);
          });
          if (noteLines.length > 10) { noteLines = noteLines.slice(0, 10); noteLines[9] += '\u2026'; }
        }
        var notesH = noteLines.length ? (90 + noteLines.length * 48) : 0;
        var H = Math.max(880, 200 + lines.length * LH + notesH);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        x.fillStyle = '#ffffff'; x.fillRect(0, 0, W, H);
        /* C15 (2026-08-25, Justin: "make sure the rulers dont override the
           images") — the LEFT GUTTER has to hold the height ruler AND its
           chip. It was 70px; the chip alone is ~100px wide and is centred on
           the ruler line, so its right half landed on top of the render (and
           its left half ran off the canvas). Reserve 150px and take it out of
           the render box so the art still clears the spec column at x=870. */
        var box = 650, bx = 150, by = (H - box) / 2;
        /* C37: white-on-white artwork needs the same neutral backdrop the
           builder stages use. Same colour (#5a5e64) so the sheet matches what
           the customer approved on screen. */
        var npTone = npBitmapTone(im);
        var artBG = (npTone.alpha && npTone.light) ? '#5a5e64' : '#ffffff';
        if (artBG !== '#ffffff') { x.fillStyle = artBG; x.fillRect(bx, by, box, box); }
        var sc = Math.min(box / im.naturalWidth, box / im.naturalHeight);
        var dw = im.naturalWidth * sc, dh = im.naturalHeight * sc;
        x.drawImage(im, bx + (box - dw) / 2, by + (box - dh) / 2, dw, dh);
        /* measuring rulers hug the DRAWN patch on the sheet itself (Justin
           2026-08-24): bounds scanned from the composed pixels by distance
           from the white backdrop (soft shadows stay excluded), chips carry
           the order's true Width/Height. Applies to AI and digital sheets. */
        try {
          var wVal = '', hVal = '';
          lines.forEach(function (lnV) {
            if (/^width/i.test(String(lnV[0]))) wVal = String(lnV[1]);
            if (/^height/i.test(String(lnV[0]))) hVal = String(lnV[1]);
          });
          /* the builder's own st.w/st.h when the line carries no size rows (np-emb2 passes them; the cart never does) */
          if (!wVal && opts && +opts.w) wVal = (+opts.w).toFixed(2);
          if (!hVal && opts && +opts.h) hVal = (+opts.h).toFixed(2);
          if (wVal || hVal) {
            var ix0 = Math.round(bx + (box - dw) / 2), iy0 = Math.round(by + (box - dh) / 2);
            var IW = Math.max(2, Math.round(dw)), IH = Math.max(2, Math.round(dh));
            var dd = x.getImageData(ix0, iy0, IW, IH).data;
            var cI = [0, (IW - 1) * 4, ((IH - 1) * IW) * 4, ((IH - 1) * IW + (IW - 1)) * 4];
            var rB = 0, gB = 0, bB2 = 0;
            cI.forEach(function (ci) { rB += dd[ci]; gB += dd[ci + 1]; bB2 += dd[ci + 2]; });
            rB /= 4; gB /= 4; bB2 /= 4;
            var mnX = IW, mxX = -1, mnY = IH, mxY = -1;
            var stp = Math.max(1, Math.round(IW / 360));
            for (var yy2 = 0; yy2 < IH; yy2 += stp) {
              for (var xx2 = 0; xx2 < IW; xx2 += stp) {
                var i5 = (yy2 * IW + xx2) * 4;
                if ((Math.abs(dd[i5] - rB) + Math.abs(dd[i5 + 1] - gB) + Math.abs(dd[i5 + 2] - bB2)) > 90) {
                  if (xx2 < mnX) mnX = xx2; if (xx2 > mxX) mxX = xx2;
                  if (yy2 < mnY) mnY = yy2; if (yy2 > mxY) mxY = yy2;
                }
              }
            }
            if (mxX > mnX && mxY > mnY) {
              var pX0 = ix0 + mnX, pX1 = ix0 + mxX + stp, pY0 = iy0 + mnY, pY1 = iy0 + mxY + stp;
              /* C23 (2026-08-25, Justin: "make sure these mockups with ruler
                 dont show like this for tackle twill" / "overhanging the
                 image"). Tackle twill (and any lettering strip) is rendered on
                 a large grey STAGE. We drew that whole stage into the sheet, so
                 the art itself ended up small and marooned in the middle — and
                 because the detected bounds are the LETTERING, deep inside the
                 stage, the rulers were laid across the stage image rather than
                 sitting outside the artwork. Re-draw cropped to the detected
                 bounds so the artwork fills the box and the rulers land in the
                 white margin where they belong.
                 Guarded: only when the art is genuinely smaller than the frame
                 and the bounds are sane, so a normal patch that already fills
                 its box is left exactly as it was. */
              try {
                var fillFrac = ((pX1 - pX0) * (pY1 - pY0)) / (IW * IH);
                var bw = (mxX + stp - mnX), bh = (mxY + stp - mnY);
                if (fillFrac < 0.80 && bw > IW * 0.04 && bh > IH * 0.04) {
                  var sxS = Math.max(0, mnX / sc), syS = Math.max(0, mnY / sc);
                  var swS = Math.min(im.naturalWidth - sxS, bw / sc);
                  var shS = Math.min(im.naturalHeight - syS, bh / sc);
                  if (swS > 1 && shS > 1) {
                    x.fillStyle = artBG; /* C37: keep the backdrop through the C23 re-draw */
                    x.fillRect(bx - 2, by - 2, box + 4, box + 4);
                    var sc2 = Math.min(box / swS, box / shS);
                    var dw2 = swS * sc2, dh2 = shS * sc2;
                    var dx2 = Math.round(bx + (box - dw2) / 2), dy2 = Math.round(by + (box - dh2) / 2);
                    x.drawImage(im, sxS, syS, swS, shS, dx2, dy2, dw2, dh2);
                    pX0 = dx2; pY0 = dy2; pX1 = dx2 + Math.round(dw2); pY1 = dy2 + Math.round(dh2);
                  }
                }
              } catch (eCrop) {}
              x.save();
              x.font = '700 30px -apple-system, "Segoe UI", sans-serif';
              x.textAlign = 'center'; x.textBaseline = 'middle';
              var tick = function (x1, y1, x2, y2) { x.beginPath(); x.moveTo(x1, y1); x.lineTo(x2, y2); x.stroke(); };
              var chip = function (cx2, cy2, txt) {
                var tw = x.measureText(txt).width + 26;
                x.fillStyle = '#ffffff'; x.lineWidth = 2;
                x.beginPath();
                if (x.roundRect) x.roundRect(cx2 - tw / 2, cy2 - 22, tw, 44, 8); else x.rect(cx2 - tw / 2, cy2 - 22, tw, 44);
                x.fill(); x.stroke();
                x.fillStyle = '#131715';
                x.fillText(txt, cx2, cy2 + 1);
              };
              x.strokeStyle = '#131715';
              if (wVal) {
                /* C15 — 24 keeps the chip's top (wy-22) on the canvas */
                var wy = Math.max(24, pY0 - 42);
                x.lineWidth = 3;
                tick(pX0, wy, pX1, wy); tick(pX0, wy - 12, pX0, wy + 12); tick(pX1, wy - 12, pX1, wy + 12);
                chip((pX0 + pX1) / 2, wy, wVal + '"');
              }
              if (hVal) {
                /* C15 — the chip is centred ON the line, so half of it sticks
                   out sideways. Park the line so the chip's RIGHT edge stops
                   short of the render instead of covering it. The line itself
                   still spans pY0..pY1 exactly — the standing rule that a
                   ruler must hug the patch is about the SPAN, not the offset. */
                var hTxt = hVal + '"';
                var hTw = x.measureText(hTxt).width + 26;
                var hx = pX0 - (hTw / 2 + 14);
                if (hx - hTw / 2 < 10) hx = hTw / 2 + 10; /* never off the left edge */
                x.lineWidth = 3;
                tick(hx, pY0, hx, pY1); tick(hx - 12, pY0, hx + 12, pY0); tick(hx - 12, pY1, hx + 12, pY1);
                /* unreachable with the 150px gutter, but never draw a chip over
                   the art: an unlabelled ruler beats a covered render */
                if (hx + hTw / 2 < pX0 - 4) chip(hx, (pY0 + pY1) / 2, hTxt);
              }
              x.restore();
            }
          }
        } catch (eRul) {}
        x.fillStyle = '#131715';
        x.textBaseline = 'middle';
        /* shrink to fit the LONGEST line inside the text column */
        var avail = W - 870 - 40, fs = 44;
        x.font = '700 44px -apple-system, "Segoe UI", sans-serif';
        var widest = 0;
        lines.forEach(function (ln) { widest = Math.max(widest, x.measureText(ln[0] + ':  ' + ln[1]).width); });
        if (widest > avail) fs = Math.max(26, Math.floor(44 * avail / widest));
        x.font = '700 ' + fs + 'px -apple-system, "Segoe UI", sans-serif';
        var blockH = (lines.length - 1) * LH + notesH;
        var ty = H / 2 - blockH / 2;
        lines.forEach(function (ln, i) { x.fillText(ln[0] + ':  ' + ln[1], 870, ty + i * LH); });
        if (noteLines.length) {
          var ny = ty + (lines.length - 1) * LH + 110;
          x.font = '700 36px -apple-system, "Segoe UI", sans-serif';
          x.fillText('Revision Notes:', 870, ny);
          x.font = '400 34px -apple-system, "Segoe UI", sans-serif';
          noteLines.forEach(function (nl, i2) { x.fillText(nl, 870, ny + 60 + i2 * 48); });
        }
        cb(cv);
      } catch (eC) { cb(null); }
    };
    im.onerror = function () { cb(null); };
    im.src = imgUrl;
  }
  /* the freshness token baked into sheet filenames (np-emb2 specDkToken): original upload + size + the sheet's own rows */
  function dkToken(artU, w, h, lines) {
    /* C460 (2026-09-30): key the artwork by its FILE NAME. The same upload is addressed through the raw S3 host for most of
       the session and through imgix once Add to Cart rewrites _Original Image, so the full URL changed at the click and
       every sheet built at approval looked stale there — rebuilt inside a 2.5s window, and ~30% of AI orders shipped the
       bare render. The name (<upload>____image_<ts>_<rand>.<ext>) is unique per upload on either host. */
    var artK = String(artU || '').split('?')[0].split('&')[0].split('/').pop();
    var dkSrc = artK + '|' + (w || 0) + 'x' + (h || 0) +
      /* C468: rows hashed in SORTED order — the click rewrites the line's properties and they come back in a different order;
         the same specs in another order are the same sheet. Any changed VALUE still changes the token. */
      '|' + (lines && lines.length ? lines.map(function (l) { return l.join(':'); }).sort().join(';') : '');
    var dkH = 5381;
    for (var iH = 0; iH < dkSrc.length; iH++) dkH = ((dkH << 5) + dkH + dkSrc.charCodeAt(iH)) >>> 0;
    return dkH.toString(36);
  }
  /* host a composed sheet through the uploads presign (np-emb2 uploadSpec); cb(imgix URL | null) */
  function uploadSheet(cv, name, cb, opts) {
    var host = (opts && opts.host) || function (u) { return u || ''; };
    var put = (opts && opts.put) || function (url, body) { return fetch(url, { method: 'PUT', body: body }); };
    try {
      cv.toBlob(function (blob) {
        if (!blob || typeof window.getPresignedUploadUrl !== 'function') { cb(null); return; }
        window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) { cb(null); return; }
          put(p.url, blob).then(function (r2) {
            var uOut = r2 && r2.ok ? host(p.sourceUrl || '') : null;
            if (uOut) uOut = uOut.replace(/([^:])\/\//g, '$1/');
            cb(uOut);
          }).catch(function () { cb(null); });
        }).catch(function () { cb(null); });
      }, 'image/png');
    } catch (eU) { cb(null); }
  }
  window.npSpecSheet = { exclude: SPEC_EXCLUDE, lines: specLines, notes: specNotes, compose: composeSpec, dk: dkToken, upload: uploadSheet };
})();
